<template>
  <div class="bg-white">
    
        <img :src="'/imgs/Hand_shake.png'" alt="" class="img" loading="lazy"/>
      
      <h1
        class="
          text-center
          mt-10
          font-extrabold
          tracking-wide
          text-9xl
          font-sans
          text-black
        "
      >
        Thank You!
      </h1>
      <p class="text-center text-gray-500 text-lg font-light">
        We have sucessfully deployed <strong>{{ productName }}</strong> to
        <strong>{{ tenantHostName }}</strong
        >.
      </p>

      <div class="text-center">
        <p>
          Click below to use the product.
          <!-- Having trouble? <a href="">Contact us</a> -->
        </p>
      </div>
      <div class="text-center">
        <button
          type="button"
          class="bg-green-500 py-1 px-3 mt-3 ml-6 rounded thanks"
        >
          <a v-bind:href="'https://'+tenantHostName+'/dashboard'" class="text-white no-underline"
            >Try Now</a>
        </button>
        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        <button
          type="button"
          class="bg-white py-1 px-4 mt-3 mr-6 rounded thank"
        >
          <a href="" class="text-green-500 no-underline">Later</a>
        </button>
      </div>
    </div>
  
</template>
<script>
export default {
  props: {
    productName: String,
    tenantHostName: String,
  },
   data() {
    return {
    
      mainUrl: null,
    };
  },
  components:{

  },
  methods: {
gotoDashBoard(){
 inertia.get(this.mainUrl)
},
    },
  mounted(){

    this.mainUrl = "https://"+this.tenantHostName+"/dashboard"

  }
}
</script>

<style>


.thank {
  border: 2px solid #10b981;
  color: #10b981;
  /* margin-right: 40px !important; */
  /* width: 45%; */
  /* color:black; */
  /* letter-spacing: 5px; */
  /* font-weight: 900; */
}
.thank:hover {
  color: #10b981;
}
.img {
  display: block;
  margin-left: auto;
  margin-right: auto;
  /* width: 50%; */
  margin-top: 70px;
}
</style>